// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Boundary} from './boundary.js'
import {Id} from './id.js'

export class ClearStyle {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ClearStyle {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsClearStyle(bb: flatbuffers.ByteBuffer, obj?: ClearStyle): ClearStyle {
    return (obj || new ClearStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsClearStyle(bb: flatbuffers.ByteBuffer, obj?: ClearStyle): ClearStyle {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ClearStyle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  start(obj?: Boundary): Boundary | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Boundary()).__init(this.bb_pos + offset, this.bb!) : null
  }

  end(obj?: Boundary): Boundary | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Boundary()).__init(this.bb_pos + offset, this.bb!) : null
  }

  paragraph(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startClearStyle(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, startOffset, 0)
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, endOffset, 0)
  }

  static addParagraph(builder: flatbuffers.Builder, paragraph: boolean) {
    builder.addFieldInt8(2, +paragraph, +false)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, textFieldOffset, 0)
  }

  static endClearStyle(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // start
    builder.requiredField(offset, 6) // end
    return offset
  }
}
